import Client from './HTTPClient';

const API = {
  list (request) {
    return Client.post('/api/oon-indoors/', request);
  },

  upload (data) {
    return Client.post('/api/oon-indoors/upload', data, true, {isJson: false, isMultipart: true});
  },

  create (request) {
    return Client.post('/api/oon-indoors/new', request);
  }
};

export default API;
